<template>
  <div>
    <loading v-if="loading"/>
    <section v-else>
      <div
          :class="$vuetify.breakpoint.smAndDown?'px-1 py-0':'px-15 py-4'"
      >
        <h3 class="font-weight-bold text-center mb-4">
          {{$t('ardakan_group')}}
        </h3>
        <h5
            :style="$vuetify.breakpoint.smAndDown?'width: 96%':'width: 53%'"
            style=";margin: auto;" class="text-center text-justify mb-4" v-html="about_us_text[`details_${lang}`]">
        
        </h5>
      </div>
      <section>
        <v-row :dir="index%2==0?'rtl':'ltr'" v-for="(row,index) in about.topics" :key="index" class="">
          <v-col
              lg="6"
              xl="6"
              cols="12"
              class="d-flex flex-column align-center justify-center "
              :class="$vuetify.breakpoint.smAndDown?'px-2':'px-16'"
          >

            <a target="_blank" :href="row.fields.length>0? row.fields[0].value:''" style="font-size: 28px"
               class="font-weight-bold text-center text-decoration-none">{{ row.title }}</a>
            <div v-html="row.details"></div>
          </v-col>
          <v-col lg="6" xl="6" cols="12">
            <img :src="row.photo_file" width="100%" :alt="row.title">
          </v-col>
        </v-row>
      </section>
    </section>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {GET_ABOUT_COMPANY} from "../../../../store/aboutManagement/action_type";

export default {
  name: 'about-deatils',
  created() {
    this.$store.dispatch(`aboutManagement/${GET_ABOUT_COMPANY}`);
    this.$store.dispatch(`aboutManagement/getAboutUsText`);
  },
  computed: {
    ...mapState({
      about: state => state.aboutManagement.aboutCompany,
      loading: state => state.aboutManagement.loading,
      about_us_text: state => state.aboutManagement.about_us_text
    }),
    lang(){
      return localStorage.getItem("lang")
    }
  }
}
</script>
